var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"competition-tabs"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.value,class:{ active: _vm.value === tab.value },on:{"click":function($event){return _vm.$emit('input', tab.value)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }